import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Login from '@/views/Login'
import Main from '@/views/Main'
import Profile from '@/views/Profile'

import Conseillers from '@/views/Conseillers/index'
import ConseillersDetails from '@/views/Conseillers/details/Details'
import Clients from '@/views/Clients/index'
import ClientsDetails from '@/views/Clients/details/Details'
import Cabinets from '@/views/Cabinets/index'
import ResetPassword from '@/views/ResetPassword'
// import CabinetsDetails from '@/views/Cabinets/details/Details'
// import Encaissements from '@/views/Encaissements/index'
// import Statistiques from '@/views/Statistiques/index'
// import ContractsSupports from '@/views/ContractsSupports/index'
// import SupportDetails from '@/views/ContractsSupports/details/SupportDetails'

// import Transactions from '@/views/Transactions/index'
// import MyTransactions from '@/views/Transactions/MyTransactions'
// import Documents from '@/views/Transactions/Documents'

// Dev Purpose
// import Demo from '@/views/demo'

Vue.use(Router);

const myRouter = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Main,
      children: [
        {
          path: '',
          name: 'Main',
          redirect: {name: 'Profile'},
        },
				{
					path: 'profile',
					component: Profile,
					name: 'Profile'
        },
				{
					path: 'conseillers/:id',
					component: ConseillersDetails,
					name: 'ConseillersDetails'
				},
				{
					path: 'conseillers',
					component: Conseillers,
					name: 'Conseillers'
        },
				{
					path: 'clients/:id',
					component: ClientsDetails,
					name: 'ClientsDetails'
				},
				{
					path: 'clients',
					component: Clients,
					name: 'Clients'
        },
				{
					path: 'cabinets',
					component: Cabinets,
					name: 'Cabinets'
				},
				{
					path: 'statistiques',
					component: null,
					name: 'Statistiques'
				},
				{
					path: 'encaissements',
					component: null,
					name: 'Encaissements'
				},
				{
					path: 'supports/:id',
					component: null,
					name: 'SupportDetails'
				},
				{
					path: 'contracts',
					component: null,
					name: 'ContractsSupports'
				}
      ]
			// children: [
			// 	{
			// 		path: 'transactions',
			// 		component: Transactions,
			// 		children: [
			// 			{
			// 				path: '',
			// 				name: 'Transactions',
			// 				redirect: {name: 'MyTransactions'}
			// 			},
			// 			{
			// 				path: 'my-transactions',
			// 				name: 'MyTransactions',
			// 				component: MyTransactions
			// 			},
			// 			{
			// 				path: 'documents',
			// 				name: 'Documents',
			// 				component: Documents
			// 			}
			// 		]
			// 	},
			// 	{
			// 		path: 'profile',
			// 		component: Profile,
			// 		name: 'Profile'
			// 	},
			// 	{
			// 		path: 'clients/:id',
			// 		component: ClientsDetails,
			// 		name: 'ClientsDetails'
			// 	},
			// 	{
			// 		path: 'clients',
			// 		component: Clients,
			// 		name: 'Clients'
			// 	},
			// 	{
			// 		path: 'cabinets/:id',
			// 		component: CabinetsDetails,
			// 		name: 'CabinetsDetails'
			// 	},
			// 	{
			// 		path: 'cabinets',
			// 		component: Cabinets,
			// 		name: 'Cabinets'
			// 	},
			// 	{
			// 		path: 'statistiques',
			// 		component: Statistiques,
			// 		name: 'Statistiques'
			// 	},
			// 	{
			// 		path: 'encaissements',
			// 		component: Encaissements,
			// 		name: 'Encaissements'
			// 	},
			// 	{
			// 		path: 'supports/:id',
			// 		component: SupportDetails,
			// 		name: 'SupportDetails'
			// 	},
			// 	{
			// 		path: 'contracts',
			// 		component: ContractsSupports,
			// 		name: 'ContractsSupports'
			// 	}
			// ]
		},
		{
			path: '/login',
			component: Login,
      name: 'Login',
      meta: {
      requiresAuth: false
      }
    },
		{
			path: '/reset-password',
			component: Login,
			name: 'ResetPasswordEmailAsk',
			meta: {
				requiresAuth: false
			}
		},
		{
			path: '/reset-password/:token',
			component: ResetPassword,
			name: 'ResetPassword',
			meta: {
				requiresAuth: false
			}
		},
		// {
		// 	path: '/demo',
		// 	component: Demo,
		// 	name: 'Demo'
		// },
		{
			path: '*',
			redirect: {name: 'Main'},
		}
	]
});

myRouter.beforeEach((to, from, next) => {
	if (store.getters.isAuthenticated && store.getters.isTokenExpired) {
		store.commit('LOGOUT')
		next({ name: 'Login' })
	} else {
		if ((typeof to.meta.requiresAuth !== 'undefined' && to.meta.requiresAuth === false) && store.getters.isAuthenticated) {
			next({ name: 'Main' })
		} else if ((typeof to.meta.requiresAuth === 'undefined' || to.meta.requiresAuth === true) && !store.getters.isAuthenticated) {
			next({ name: 'Login' })
		} else {
			next()
		}
	}
})

export default myRouter



// WEBPACK FOOTER //
// ./src/router/index.js